import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder, accessNested } from 'utils/utils';

import Store from 'store/store';

import Facebook from 'components/bolt/icons/facebook';
import Twitter from 'components/bolt/icons/twitter';
import Twitch from 'components/bolt/icons/twitch';
import Instagram from 'components/bolt/icons/instagram';
import Youtube from 'components/bolt/icons/youtube';
import Snapchat from 'components/bolt/icons/snapchat';
import Tiktok from 'components/bolt/icons/tiktok';
import Spotify from 'components/bolt/icons/spotify';
import Pinterest from 'components/bolt/icons/pinterest';
import Giphy from 'components/bolt/icons/giphy';
import Tumblr from 'components/bolt/icons/tumblr';
import Vimeo from 'components/bolt/icons/vimeo';
import Mail from 'components/bolt/icons/mail';

import Link from 'components/bolt/link/link';

import s from 'components/bolt/socials/socials.sss';

export default class Socials extends Component {
	render(props) {
		const { socials = {}, navOpen } = props;

		const icons = {
			facebook: <Facebook class={s.icon} />,
			twitter: <Twitter class={s.icon} />,
			// twitch: <Twitch class={s.icon} />,
			instagram: <Instagram class={s.icon} />,
			youtube: <Youtube class={s.icon} />,
			snapchat: <Snapchat class={s.icon} />,
			tiktok: <Tiktok class={s.icon} />,
			spotify: <Spotify class={s.icon} />,
			pinterest: <Pinterest class={s.icon} />,
			giphy: <Giphy class={s.icon} />,
			tumblr: <Tumblr class={s.icon} />,
			vimeo: <Vimeo class={s.icon} />,
			email: <Mail class={s.icon} />,
		};

		const entries = Object.entries(socials);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});
		const isRTL = accessNested(Store.get(), 'appData.styling.fontVariables.textDirection') === 'rtl';

		return (
			<div class={joinClasses(s.socials, props.class, navOpen && s.navOpen)}>
				{sortObjectByOrder(socials).slice(0, 5).map(social => {
					const id = entries.find(el => el[1].destination === social.destination)[0];
					let icon = icons[id];
					if (!icon && social.iconURL) {
						const iconSrc = (navOpen && social.iconNav) ? social.iconNav : social.iconURL;
						icon = <img class={s.icon} src={iconSrc} alt='' />;
					}

					return (
						<Link
							class={joinClasses(s.social, s[id], isRTL && s.rtlSocial)}
							href={social.destination}
							target="_blank"
							rel="noopener noreferrer"
							key={id}
							onClick={()=> {Store.emit('CLICKED_FOLLOW', id);}}
							ariaLabel={accessibilityCopy.$SOCIAL_ARIA.replace('<platform>', id)}
						>
							{icon}
						</Link>
					);
				})}
			</div>
		);
	}
}
